import { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'

interface IIdIsCopiedProps extends WithTranslation {
  idCopied: boolean
  value?: boolean
}

class IdIsCopied extends Component<IIdIsCopiedProps> {
  render() {
    const { t } = this.props

    return (
      <div className="IDCopiedPopUpTable">
        <div className="IDCopiedPopUpCell">
          <div className={this.props.idCopied ? 'IDCopiedPopUpShow' : 'IDCopiedPopUpHide'}>
            {this.props.value ? t('VALUE_COPIED_TO_CLIPBOARD') : t('ID_COPIED_TO_CLIPBOARD')}
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation('common')(IdIsCopied)
